import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import CircularProgress from 'material-ui/CircularProgress';

export class ActionButton extends Component {
  state = {
    is_saving: false,
  }

  handleClick = (e) => {
    if (this.is_saving) {
      e.preventDefault();
    } else {
      if (this.props.action) {
        Promise
          .resolve()
          .then(() => (this.setState({ is_saving: true })))
          .then(() => (this.props.action()))
          .then(() => (this.setState({ is_saving: false })));
      }
    }
  };

  render() {
    if (!this.props.action) {
      return null;
    }

    const ButtonComponent = this.props.is_raised ? RaisedButton : FlatButton;

    const { is_saving } = this.state
    const { label = 'Save' } = this.props;
    return (
      <ButtonComponent
        type='button'
        label={label}
        icon={is_saving ? <CircularProgress size={25} thickness={2} /> : null}
        onClick={this.handleClick}
        primary={!is_saving}
      />
    );
  }
}

ActionButton.propTypes = {
  label: PropTypes.string,
};

export default ActionButton;



// WEBPACK FOOTER //
// ./src/components/button/ActionButton.js